<template>
  <div>
    <div v-if="request_prefix === 'bigScreen'">
    <ul class="bar-styles">
      <li
        class="bar-style-item"
        @click="changeBarStyle(style, index)"
        :class="style.chartOption.styleId && style.chartOption.styleId === options.chartOption.styleId ? 'active' : ''"
        v-for="(style, index) in showStyles"
        :key="index"
      >
        <div class="chart_style_img_box" :class="request_prefix === 'bigScreen' ? '' : 'lightBgColor'">
          <img class="chart_style_img" :src="barImgs[index]" alt="" />
        </div>
        <p class="style_title" :class="request_prefix === 'bigScreen' ? '' : 'home_style_title'">样式{{ index + 1 }}</p>
      </li>
    </ul>
    <el-collapse class="expand-el-collapse bar-list-box" v-model="activeNames" v-if="moreStyles.length > 0">
      <el-collapse-item :title="activeNames.length > 0 ? '收起' : '展开'" name="1">
        <ul class="bar-styles flex" :class="request_prefix === 'bigScreen' ? '' : 'barStyleHome'">
          <li
            class="bar-style-item"
            @click="changeBarStyle(style, index + showLen)"
            :class="style.chartOption.styleId && style.chartOption.styleId === options.chartOption.styleId ? 'active' : ''"
            v-for="(style, index) in moreStyles"
            :key="index + showLen"
          >
            <img class="chart_style_img_box" :src="barImgs[index + showLen]" alt="" />
            <p class="style_title" :class="request_prefix === 'bigScreen' ? '' : 'home_style_title'">
              样式{{ showLen + index + 1 }}
            </p>
          </li>
        </ul>
      </el-collapse-item>
    </el-collapse>
    </div>
    <local-style
      v-else
      class="template-styles"
      :options="options"
      :container_id="ids.container_id"
      :rect_id="ids.rect_id"
      elementType="barComponent"
      :styleImgs="barImgs"
      ref="localStyleComponent"
    />
  </div>
</template>

<script>
import localStyle from "toolbarComponents/styles/local-style.vue"
export default {
  name: "bar-options-style",
  components: {localStyle},
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    barStyles() {
      let menu =
        this.request_prefix === "bigScreen" ? this.$store.state.bigScreenMenu.menu : this.$store.state.menu.menu
      let styles = [],
        stylesOption = []
      for (let i = 0; i < menu.children.length; i++) {
        if (menu.children[i].type === "chart") {
          for (let j = 0; j < menu.children[i].children.length; j++) {
            if (menu.children[i].children[j].type === "barComponent") {
              styles = menu.children[i].children[j].children
              break
            }
          }
          break
        }
      }
      styles.forEach(item => {
        stylesOption.push(item.attribute.options)
      })
      return stylesOption
    },
    showStyles() {
      return this.barStyles.length > this.showLen ? this.barStyles.slice(0, this.showLen) : this.barStyles
    },
    moreStyles() {
      return this.barStyles.length > this.showLen ? this.barStyles.slice(this.showLen) : []
    },
    getChartStyle() {
      if (this.options) {
        return {
          height: this.options.height + "px",
          transform: "rotate(" + this.options.rotate + "deg)"
        }
      } else return null
    }
  },
  data() {
    return {
      activeIndex: undefined,
      activeNames: [],
      showLen: 6,
      barImgs: [
        require("toolbarComponents/bigScreen/image/bar1.png"),
        require("toolbarComponents/bigScreen/image/bar2.png"),
        require("toolbarComponents/bigScreen/image/bar3.png"),
        require("toolbarComponents/bigScreen/image/bar4.png"),
        require("toolbarComponents/bigScreen/image/bar5.png"),
        require("toolbarComponents/bigScreen/image/bar6.png"),
        require("toolbarComponents/bigScreen/image/bar7.png"),
        require("toolbarComponents/bigScreen/image/bar8.png"),
        require("toolbarComponents/bigScreen/image/bar9.png"),
        require("toolbarComponents/bigScreen/image/bar10.png"),
        require("toolbarComponents/bigScreen/image/bar11.png"),
        require("toolbarComponents/bigScreen/image/bar12.png")
      ]
    }
  },
  methods: {
    changeBarStyle(style, index) {
      this.activeIndex = index
      let tmpData = JSON.parse(JSON.stringify(style))
      tmpData.chartOption.reload = true
      // tmpData.left = curOptions.left
      // tmpData.top = curOptions.top
      // tmpData.width = curOptions.width
      // tmpData.height = curOptions.height
      this.$changeOptionsEV(tmpData.chartOption, "chartOption", false)
      //  以上操作有一个延时
      setTimeout(() => {
        this.$emit("changeOption")
      }, 100)
    },
    showAllStyles() {
      this.$refs.localStyleComponent.showAllStyles()
    },
  }
}
</script>

<style lang="scss" scoped>
.bar-styles {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  &.barStyleHome {
    .chart_style_img_box {
      background: #f5f6f8;
      border-color: #e9e9e9;
    }
  }
}
.bar-style-item {
  position: relative;
  display: inline-block;
  width: calc((100% - 16px)/3);
  margin-right: 8px;
  margin-bottom: 12px;
  border-radius: 4px;
  cursor: pointer;
  &:nth-child(3n) {
    margin-right: 0;
  }
  .chart_style_img_box {
    width: 100%;
    height: 52px;
    border: 2px solid;
    box-sizing: content-box;
    border-color: transparent;
    border-radius: 4px;
    background-color: #131418;
    &.lightBgColor {
      background: #f5f6f8;
      border-color: #e9e9e9;
    }
    .chart_style_img {
      width: 100%;
      height: 100%;
    }
  }
  &:hover {
    .chart_style_img_box {
      border-color: rgba(23, 112, 255, 0.3);
    }
  }
  &.active {
    .chart_style_img_box {
      border-color: var(--themeColor);
    }
    .style_title {
      color: rgba(255, 255, 255, 0.8);
      &.home_style_title {
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
}
.style_title {
  margin-top: 6px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  &.home_style_title {
    color: rgba(0, 0, 0, 0.6);
  }
}
.bar-style-item:last-child {
  margin-right: 0px;
}
</style>
<style lang="scss">
.bar-list-box {
  .el-collapse-item__wrap {
    overflow: visible;
  }
}
</style>
